<div
    class="flex items-center mb-2"
    [ngClass]="allowMapSearch() ? 'justify-between' : 'justify-end'">
    @if (allowMapSearch()) {
        <app-global-search />
    }
    @if (
        filterResolverService.currentFilterType() === FilterTypeEnum.MAP_ENTITIES &&
        mapFilterService.selectedFilters().length
    ) {
        <div class="flex-1 min-w-0 flex mx-2 max-h-8 border-gray-400">
            <app-active-filter-content class="w-full" />
        </div>
    }
    <div [class]="isFieldInterventionSelectionToolbarVisible() ? ' flex flex-row justify-between w-full' : ''">
        @if (isFieldInterventionSelectionToolbarVisible()) {
            <div class="content-toolbar flex items-center">
                <fa-icon
                    class="hover:text-primary transition-colors cursor-pointer text-custom-blue pl-1"
                    size="2xl"
                    [icon]="['far', 'arrow-left']"
                    [matTooltip]="'back' | transloco"
                    (click)="goBack()" />
                <h1 class="pl-5 pr-20 !m-0 !font-normal">
                    {{ createFieldInterventionService.fieldInterventionName() }}
                </h1>
                @if (createFieldInterventionService.activeLayers().length) {
                    <app-layer-select [hasTabularLayers]="false" />
                }
            </div>
        }
        <div class="content-toolbar flex flex-wrap items-center gap-3">
            @if (filterResolverService.currentFilterType()) {
                <app-filter-menu />
            }

            <app-button
                [disabled]="!hasTableViewPermissions()"
                [label]="(contentLayoutService.isDataTableView() ? 'mapView' : 'tableView') | transloco"
                [tooltip]="hasTableViewPermissions() ? undefined : ('insufficientPermissions' | transloco)"
                [type]="ButtonType.SECONDARY"
                (onClick)="hasTableViewPermissions() ? contentLayoutService.toggleIsDataView() : null" />

            <mat-button-toggle-group
                aria-label="View Mode"
                [hideSingleSelectionIndicator]="true"
                [ngModel]="contentLayoutService.mapSizeType()"
                (change)="toggleMapSizeType($event)">
                @for (iconPathEntry of Object.values(contentLayoutService.gridParams()); track iconPathEntry.path) {
                    <mat-button-toggle
                        [disabled]="
                            !panelService.currentPanel() ||
                            iconPathEntry.disabledForPanels?.includes(panelService.currentPanel()!) ||
                            (isTableEditModeActive() && iconPathEntry.class === 'map-one-third-vertical')
                        "
                        [value]="iconPathEntry">
                        <svg-icon
                            class="size-icon"
                            [src]="iconPathEntry?.path"
                            [svgStyle]="{ 'width.px': 30, 'height.px': 30 }" />
                    </mat-button-toggle>
                }
            </mat-button-toggle-group>
        </div>
    </div>
</div>
